'use strict';

var index = require('../numbers/index.cjs');
var units = require('../numbers/units.cjs');
var sanitize = require('../utils/sanitize.cjs');
var utils = require('./utils.cjs');

const hsla = {
    test: /*@__PURE__*/ utils.isColorString("hsl", "hue"),
    parse: /*@__PURE__*/ utils.splitColor("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
        return ("hsla(" +
            Math.round(hue) +
            ", " +
            units.percent.transform(sanitize.sanitize(saturation)) +
            ", " +
            units.percent.transform(sanitize.sanitize(lightness)) +
            ", " +
            sanitize.sanitize(index.alpha.transform(alpha$1)) +
            ")");
    },
};

exports.hsla = hsla;
//# sourceMappingURL=hsla.cjs.map
